import axios from "axios"

export default async function fetchOrders() {
    const token = JSON.parse(
        localStorage.getItem("pass_ticket_token") || "null"
    )

    const { data } = await axios.get(
        `${process.env.NEXT_PUBLIC_API_URL}users/orders`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    )

    return data
}
